var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "login-button-wrapper",
      on: { mouseenter: _vm.updateMessages },
    },
    [
      _c(
        "button",
        {
          ref: "loginButton",
          staticClass: "login-button btn",
          class: _vm.busy ? "busy disabled" : "",
          attrs: { role: "button", disabled: _vm.busy },
          on: { click: _vm.onClick },
        },
        [_vm._v(_vm._s(_vm.$t("user.login"))), _vm._t("default")],
        2
      ),
      !_vm.disableTooltip &&
      _vm.popoverTarget &&
      (_vm.showSessionExpired || _vm.showRegistrationInfo)
        ? _c(
            "dx-popover",
            {
              attrs: {
                role: "tooltip",
                visible: _vm.showPopover,
                animation: _vm.animationConfig,
                position: _vm.position,
                target: _vm.popoverTarget,
                "wrapper-attr": { class: "login-popover-wrapper" },
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showPopover = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "popover-message" },
                [
                  _vm.showSessionExpired
                    ? _c(
                        "silhouette-assistant",
                        {
                          attrs: {
                            "image-name": "silhouette-1.svg",
                            "bubble-nr": 2,
                            reverse: true,
                          },
                        },
                        [
                          _c("div", [_vm._v(_vm._s(_vm.$t("user.loggedOut")))]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("user.loggedOutLoginPrompt"))),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              on: { click: _vm.loginDismiss },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.okUnderstood")))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "dx-tooltip",
                    {
                      attrs: {
                        visible: _vm.showRegistrationInfo,
                        target: _vm.popoverTarget,
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.showRegistrationInfo = $event
                        },
                      },
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "RegistrationInfo" } } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("signup.loginButtonRegistrationTooltip")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }